<template>
  <v-carousel
    v-model="carouselIndex"
    cycle
    interval="3000"
    hide-delimiter-background
    show-arrows-on-hover
    hide-delimiters
  >
    <v-carousel-item
      v-for="({ machine, oeePercent, oeePercentGoal }, index) in list"
      :key="index"
    >
      <v-card
        color="primary"
        class="fill-height pa-4"
      >
        <div class="d-flex align-center mb-2">
          <span class="text-subtitle-1 mainfont">{{ machine }}</span>
          <v-spacer />
          <!-- 最多10个点 -->
          <button
            v-for="(_item, i) in list.slice(0, 10)"
            :key="i"
            @click="carouselIndex = i"
          >
            <v-sheet
              height="10"
              width="10"
              :color="carouselIndex === i ? 'success' : '#5F626C'"
              class="rounded-circle ml-2"
            />
          </button>
        </div>
        <v-row style="height: calc(100% - 40px);">
          <v-col style="position: relative;">
            <v-progress-circular
              style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"
              :size="185"
              :width="10"
              :rotate="-90"
              :value="oeePercentGoal"
            />
            <v-progress-circular
              style="position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);"
              :size="135"
              :width="10"
              :rotate="-90"
              :value="oeePercent"
              color="success"
            >
              <span class="text-h5">
                {{ oeePercent.toFixed(2) }}%
              </span>
            </v-progress-circular>
          </v-col>
          <v-col class="d-flex flex-column justify-space-around">
            <div>
              <div class="d-flex mb-4">
                <span>{{ $t('title.oeegoal') }}</span>
                <v-spacer />
                <span>{{ oeePercentGoal.toFixed(2) }}%</span>
              </div>
              <v-progress-linear
                :value="oeePercentGoal"
                :height="10"
                color="white"
              />
            </div>
            <div>
              <div class="d-flex mb-4">
                <span>{{ $t('title.oeereal') }}</span>
                <v-spacer />
                <span>{{ oeePercent.toFixed(2) }}%</span>
              </div>
              <v-progress-linear
                :value="oeePercent"
                :height="10"
                color="success"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'OeeCard',
  props: {
    height: {
      type: Number,
      default: 64,
    },
    list: {
      type: Array,
      default: () => [
        {
          machine: '设备-001',
          oeePercentGoal: 80,
          oeePercent: 82.1,
        },
        {
          machine: '设备-002',
          oeePercentGoal: 81,
          oeePercent: 89.8,
        },
      ],
    },
  },
  data() {
    return {
      carouselIndex: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
